import { render } from "./ProductDetails.vue?vue&type=template&id=192ae838&scoped=true"
import script from "./ProductDetails.vue?vue&type=script&lang=js"
export * from "./ProductDetails.vue?vue&type=script&lang=js"

import "./ProductDetails.vue?vue&type=style&index=0&id=192ae838&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192ae838"]])

export default __exports__